import { FC, ReactElement, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Input from '../../components/input'
import Modal from '../../components/modal'
import SelectInput, { OptionsType } from '../../components/selectInput'
import { usePlans } from '../../hooks/plans'
import { ContainerCancelPlan } from './style'

const options = [
  { label: 'Não gostei do CalcLab', value: 'Não gostei do CalcLab' },
  { label: 'Achei muito caro', value: 'Achei muito caro' },
  { label: 'Ainda sou estudante', value: 'Ainda sou estudante' },
  { label: 'Tive problemas técnicos utilizando', value: 'Tive problemas técnicos utilizando' },
  { label: 'Outro', value: 'other' }
]

const ModalCancelPlan: FC = (): ReactElement | null => {
  const { search } = useLocation()
  const history = useHistory()

  const [reason, setReason] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [reasonSelector, setReasonSelector] = useState<OptionsType | null>(null)
  const { cancel, get } = usePlans()

  const submit = async () => {
    setIsLoading(true)
    try {
      await cancel(reasonSelector?.value === 'other' ? reason : reasonSelector?.value)
      await get({ status: 'active' })
      history.replace({ search: '' })
    } catch {}
    setIsLoading(false)
  }

  const query = new URLSearchParams(search)

  if (query.get('modal') !== 'cancel') return null

  return (
    <Modal
      isLoading={isLoading}
      variantButton='danger'
      okButtonText='SIM QUERO CANCELAR'
      title='Cancelamento de plano'
      onOk={submit}
      onClose={() => history.replace({ search: '' })}
    >
      <ContainerCancelPlan>
        Você quer cancelar o seu plano?
        após o cancelamento do plano você terá apenas acesso até o final da
        recorrencia do seu plano.
        <SelectInput
          label='Por qual motivo deseja cancelar o plano?'
          options={options}
          value={reasonSelector}
          onChange={e => setReasonSelector(e)}
        />
        {reasonSelector?.value === 'other' && (
          <Input
            type='textarea'
            value={reason}
            onChange={(e: { target: { value: string } }) => setReason(e.target.value)}
            label='Preencha o motivo'
          />
        )}
      </ContainerCancelPlan>
    </Modal>
  )
}

export default ModalCancelPlan
